// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Content051_wrapper__K4AoY","title":"Content051_title__t5Zsk"};